import { useState } from 'react'

import { DialogProps } from '@fortem-monorepo/react-ui'
import { LoadingButton } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { useSendBearScenarioEmailMutation } from '@/react-query/mutations/batch-executor'
import { useFunds } from '@/react-query/queries/funds/funds'

export interface SendBearScenarioModalProps extends DialogProps {}

export const SendBearScenarioModal: React.FC<SendBearScenarioModalProps> = ({ ...props }) => {
  const [fund_name, setFundName] = useState<string>()

  const { data, query } = useFunds()

  const sendBearScenarioEmail = useSendBearScenarioEmailMutation()

  const inputsDisabled = query.isFetching || sendBearScenarioEmail.isPending
  const canSubmit = !inputsDisabled && !!fund_name

  return (
    <Dialog
      onOpenChange={(o) => {
        if (!o) {
          setFundName(undefined)
        }
      }}
      {...props}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add a Funds Entry</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <p>Run bear scenario for the past 60 business days.</p>
          <SearchSelect
            placeholder={'Select a fund'}
            options={data.map((fund) => ({ label: fund.fund_name, value: fund.fund_name }))}
            value={fund_name}
            setValue={(val) => setFundName(val)}
          />
        </div>
        <DialogFooter>
          <Button onClick={() => props?.onOpenChange?.(false)} variant={'destructive'}>
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            disabled={!canSubmit}
            onClick={() => sendBearScenarioEmail.mutateAsync({ fund_name: fund_name! })}
          >
            Submit
          </LoadingButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
